




















import { Component, Vue } from "vue-property-decorator";
import ButtonComponent from "./ButtonComponent.vue";
import PersonalDetailsComponent from "./PersonalDetailsComponent.vue";

@Component({
  components: {
    personalDetailsComponent: PersonalDetailsComponent
  }
})
export default class AboutComponent extends Vue {}
